import React from "react";

import { translate } from "react-polyglot";
import { isMobile } from 'lib/checkuseros';

import useMediaQuery from "../../../../hooks/useMediaQuery";
import ArrowGif from "./assets/arrow.gif";
import DesktopMp4 from "./assets/desktop-format-2.mp4";
import DesktopWebM from "./assets/desktop-format-1.webm";

import MobileMp4 from "./assets/mobile-format-2.mp4";
import MobileWebM from "./assets/mobile-format-1.webm";

import Button from "../button";

import "./styles.less";

const BlockStart = ({
  t,
  registrationRedirectionURL,
  splashScreenVisibilityStatus,
}) => {
  const isMobileWidth = useMediaQuery("(max-width: 768px)");
  const isMobileOS = isMobile()

  const scrollToNextBlock = () => {
    const scrollTo = document.querySelector(".block-slider__container");
    scrollTo.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleRegistrationClick = () => {
    if (isMobileOS) {
      window.location.assign(`${window.location.origin}/redirects/checkos_redirect.html`);
      return;
    }
    
    window.location.assign(registrationRedirectionURL);
  };

  return (
    <div className="block-start__container">
      <video
        loop
        muted
        autoPlay
        controls={false}
        playsInline
        preload="auto"
        className="block-start__background-media"
      >
        {isMobileWidth ? (
          <>
            <source src={MobileMp4} type="video/mp4" />
            <source src={MobileWebM} type="video/webm" />
          </>
        ) : (
          <>
            <source src={DesktopMp4} type="video/mp4" />
            <source src={DesktopWebM} type="video/webm" />
          </>
        )}
      </video>
      <div className="block-start__inner-wrapper">
        <h1 className="block-start__title">{t("landing.block-start.title")}</h1>
        <h2 className="block-start__subtitle">
          {t("landing.block-start.subtitle")}
        </h2>
        <div className={`block-start__button block-start__button--${!splashScreenVisibilityStatus? 'animation': ''}`} onClick={handleRegistrationClick}>
          <Button
            handleClick={handleRegistrationClick}
            size="lg"
            text={t("landing.block-start.button")}
            isIcon={false}
            variant="filled"
          />
        </div>
      </div>
      <div className="block-start__scroll">
        <p className="block-start__scroll-text">
          {t("landing.block-start.scroll-text")}
        </p>
        <button
          className="block-start__scroll-button"
          onClick={scrollToNextBlock}
        >
          <div className="block-start__scroll-arrow">
            <img
              className="block-start__scroll-arrow-img"
              src={ArrowGif}
              alt="Arrow scroll down"
            />
          </div>
        </button>
      </div>
    </div>
  );
};

export default translate()(BlockStart);



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-start/index.js